import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";
import { overlayTextsNullableSchema } from "../overlay-text.js";

export const updateStorySchema = z.object({
	caption: z.string().max(500).optional(),
	overlay_texts: overlayTextsNullableSchema,
	zoom: z.number().min(0.25).max(4).optional(),
	rotation: z.number().optional(),
	background_color: z.string().nullable().optional(),
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
});

export type UpdateStoryPayload = z.infer<typeof updateStorySchema>;
